/**
 * Default name/email for contact forms from auth user (login payload vs /me shape).
 */
export function getContactFormDefaultsFromUser(user) {
  if (!user) {
    return { name: '', email: '' };
  }

  const email = (user.email || '').trim();

  const first =
    user.first_name ??
    user.firstName ??
    user.profile?.first_name ??
    '';
  const last =
    user.last_name ??
    user.lastName ??
    user.profile?.last_name ??
    '';

  const name =
    [first, last]
      .map((s) => (s || '').trim())
      .filter(Boolean)
      .join(' ')
      .trim() ||
    (user.username || '').trim() ||
    '';

  return { name, email };
}

/** Full form state with name/email from profile when logged in */
export function getEmptyContactFormState(user) {
  const d = getContactFormDefaultsFromUser(user);
  return {
    name: d.name,
    email: d.email,
    inquiryType: 'general',
    subject: '',
    message: ''
  };
}
